import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import { formatDateTime } from 'rebook/apps/utils/datetime';

import styles from './style.scss';


const BookRentInfo = ({ book }) => {
  const rentValidTill = get(book, 'rent_valid_till', null);
  const tillDate = formatDateTime(rentValidTill, 'DD.MM.YYYY');
  const isAudio = get(book, 'type', '') === 'audio';
  const linkToBookText = isAudio ? 'Начать слушать' : 'Начать читать';

  return (
    <div className={classNames(styles.bookRentInfo, 'jest-rented-book-info')}>
      <div className={styles.header}>
        <div className={styles.successImage} />
        <div className={styles.headerText}>
          <span><b>Уже в аренде</b></span>
        </div>
        <div className={styles.headerTitle}>
          <span>
            Вы уже взяли эту {isAudio ? 'аудиокнигу' : 'книгу'} в аренду. Она доступна&nbsp;
            <br className={styles.mobileTitleText} />
            для {isAudio ? 'прослушивания в приложениях' : 'чтения в Моих книгах'} до <b>{tillDate}</b>
          </span>
        </div>
      </div>
      <div className={styles.linkContainer}>
        <Link className="jest-link-to-user-books" to={{ pathname: book.absolute_url, state: { book } }}>
          <span className="link">
            {linkToBookText}
          </span>
          <span className={classNames('arrowRight', styles.arrow)} />
        </Link>
      </div>
    </div>
  );
};

BookRentInfo.propTypes = {
  book: PropTypes.shape({
    rent_valid_till: PropTypes.string.isRequired,
  }),
  user: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

export default BookRentInfo;
